import type { TypedDocumentNode } from '@apollo/client';
import type {
  CreateExpenseType,
  CreateExpenseTypeVariables,
  DeleteExpenseType,
  DeleteExpenseTypeVariables,
  ExpenseTypeQuery,
  ExpenseTypeQueryVariables,
  UpdateExpenseType,
  UpdateExpenseTypeVariables,
} from 'types/graphql';

const Create: TypedDocumentNode<CreateExpenseType, CreateExpenseTypeVariables> = gql`
  mutation CreateExpenseType($input: CreateExpenseTypeInput!) {
    createExpenseType(input: $input) {
      id
      name
      disabled
      payablesAccount {
        id
        accountName
      }
      receivablesAccount {
        id
        accountName
      }
      accountLevels
    }
  }
`;

const Update: TypedDocumentNode<UpdateExpenseType, UpdateExpenseTypeVariables> = gql`
  mutation UpdateExpenseType($id: Int!, $input: UpdateExpenseTypeInput!) {
    updateExpenseType(id: $id, input: $input) {
      id
      name
      disabled
      payablesAccount {
        id
        accountName
      }
      receivablesAccount {
        id
        accountName
      }
      accountLevels
    }
  }
`;

const Delete: TypedDocumentNode<DeleteExpenseType, DeleteExpenseTypeVariables> = gql`
  mutation DeleteExpenseType($id: Int!) {
    deleteExpenseType(id: $id) {
      id
    }
  }
`;

const Find: TypedDocumentNode<ExpenseTypeQuery, ExpenseTypeQueryVariables> = gql`
  query ExpenseTypeQuery($id: Int!) {
    expenseType(id: $id) {
      id
      isActivePayable
      isActiveReceivable
    }
  }
`;

export default { Create, Update, Delete, Find };
